<template>
  <div style="margin-top: 5rem;">

    <div>
        <b-img src="/public/downloads/directories/images/Letterbox.jpg" fluid alt="Briefkasten"></b-img>
    </div>

    <h2 style="margin-top: 2rem;">Adressen-Update</h2>

    <p>
    Wenn Du Deine Adresse nicht bereits per Email-Formular aktualisiert hast oder in der Zwischenzeit schon wieder eine neue
    Handy-Nummer oder Adresse hast, besteht hier die Möglichkeit, schnell und unkompliziert Deine persönlichen Kontaktdaten zu aktualisieren.
    </p>

    <b-container fluid style="margin-top: 2rem;">
        <b-form @submit.prevent="login" @reset="onReset" v-if="show">
              <b-form-group
                label="Vorname:"
                horizontal
                label-text-align="right"
                label-for="firstName"
              >
                <b-form-input id="firstName"
                          type="text"
                          v-model="form.firstName"
                          required
                          placeholder="Enter Firstname">
                </b-form-input>
              </b-form-group>

              <b-form-group
                label="Nachname:"
                horizontal
                label-text-align="right"
                label-for="surName"
              >
                <b-form-input id="surName"
                          type="text"
                          v-model="form.surName"
                          required
                          placeholder="Enter Surname">
                </b-form-input>
              </b-form-group>

              <b-form-group
                label="Gymnasium:"
                horizontal
                label-text-align="right"
                label-for="gymnasium"
              >
                <b-form-input id="gymnasium"
                          type="text"
                          v-model="form.gymnasium"
                          placeholder="Enter secondary School">
                </b-form-input>
              </b-form-group>

              <b-form-group
                label="Studium / Beruf:"
                horizontal
                label-text-align="right"
                label-for="profession"
              >
                <b-form-input id="profession"
                          type="text"
                          v-model="form.profession"
                          required
                          placeholder="Enter Profession">
                </b-form-input>
              </b-form-group>

              <b-form-group
                label="Geburtsdatum:"
                horizontal
                label-text-align="right"
                label-for="birthday"
              >
                <b-form-input id="birthday"
                          type="date"
                          v-model="form.birthday"
                          required
                          placeholder="Enter Birthday">
                </b-form-input>
              </b-form-group>

              <b-form-group
                label="Abi-Jahrgang:"
                horizontal
                label-text-align="right"
                label-for="exam"
              >
                <b-form-input id="exam"
                          type="number"
                          v-model="form.exam"
                          placeholder="Enter Exam">
                </b-form-input>
              </b-form-group>

              <b-form-group
                label="Straße:"
                horizontal
                label-text-align="right"
                label-for="street"
              >
                <b-form-input id="street"
                          type="text"
                          v-model="form.street"
                          required
                          placeholder="Enter Street">
                </b-form-input>
              </b-form-group>

              <b-form-group
                label="Postleitzahl:"
                horizontal
                label-text-align="right"
                label-for="zipCode"
              >
                <b-form-input id="zipCode"
                          type="number"
                          v-model="form.zipCode"
                          required
                          placeholder="Enter Zipcode">
                </b-form-input>
              </b-form-group>

              <b-form-group
                label="Stadt:"
                horizontal
                label-text-align="right"
                label-for="city"
              >
                <b-form-input id="city"
                          type="text"
                          v-model="form.city"
                          required
                          placeholder="Enter City">
                </b-form-input>
              </b-form-group>

              <b-form-group
                label="Bundesland / Bundesstaat<sup>(1)</sup>:"
                horizontal
                label-text-align="right"
                label-for="state"
              >
                <b-form-input id="state"
                          type="text"
                          v-model="form.state"
                          placeholder="Enter State">
                </b-form-input>
              </b-form-group>

              <b-form-group
                label="Land<sup>(1)</sup>:"
                horizontal
                label-text-align="right"
                label-for="country"
              >
                <b-form-input id="country"
                          type="text"
                          v-model="form.country"
                          placeholder="Enter Country">
                </b-form-input>
              </b-form-group>

              <b-form-group
                label="Mobilfunknummer:"
                horizontal
                label-text-align="right"
                label-for="mobilePhoneNumber"
              >
                <b-form-input id="mobilePhoneNumber"
                          type="text"
                          v-model="form.mobilePhoneNumber"
                          placeholder="Enter Cell Phone Number">
                </b-form-input>
              </b-form-group>

              <b-form-group
                label="Festnetznummer:"
                horizontal
                label-text-align="right"
                label-for="phoneNumber"
              >
                <b-form-input id="phoneNumber"
                          type="text"
                          v-model="form.phoneNumber"
                          placeholder="Enter Phone Number">
                </b-form-input>
              </b-form-group>

              <b-form-group
                label="Email:"
                horizontal
                label-text-align="right"
                label-for="email"
              >
                <b-form-input id="email"
                          type="email"
                          v-model="form.email"
                          required
                          placeholder="Enter Email">
                </b-form-input>
              </b-form-group>

              <div class="custom-control custom-checkbox" style="text-align: center">
                <input type="checkbox" class="custom-control-input" id="newsletter" v-model="form.newsletter" >
                <label class="custom-control-label" for="newsletter">Ja, ich möchte auch weiterhin schriftlich informiert werden.</label>
              </div>

              <div class="custom-control custom-checkbox" style="text-align: center">
                <input type="checkbox" class="custom-control-input" id="visible" v-model="form.visible">
                <label class="custom-control-label" for="visible">Ja, andere Bundesbrüder dürfen meine Adresse einsehen.</label>
              </div>

              <p style="margin-top: 2rem;">
                <sup>(1)</sup>: Angabe nur notwendig, wenn Du außerhalb von Deutschland lebst.
              </p>

              <div style="margin-top: 3em;">
                  <b-button type="submit" variant="primary">Absenden</b-button>
                  <b-button type="reset" variant="danger">Reset</b-button>
              </div>
        </b-form>
    </b-container>

        <div style="margin-top: 2rem;">
          <p class="error" v-if="errorStatus.message">{{ errorStatus.message }}</p>
          <p class="success" v-if="successStatus.message">{{ successStatus.message }}</p>
        </div>

  </div>
</template>

<style>
.error {
    color: red;
}
.success {
    color: limeGreen;
}
</style>

<script>
  import {ADDRESS_UPDATE_REQUEST} from '@/store/actions/addressUpdate'

  export default {
    name: 'login',
    data () {
     return {
          errorStatus: {message: ''},
          successStatus: {message: ''},
          form: {
            firstName: '',
            surName: '',
            gymnasium: '',
            profession: '',
            birthday: '',
            exam: '',
            street: '',
            zipCode: '',
            city: '',
            state: '',
            country: '',
            mobilePhoneNumber: '',
            phoneNumber: '',
            email: '',
            newsletter: true,
            visible: true
          },
          show: true
      }
    },
    methods: {
        login: function () {
            const { firstName,surName,gymnasium,profession,birthday,exam,street,zipCode,city,state,country,mobilePhoneNumber,phoneNumber,email,newsletter,visible } = this.form
            this.$store.dispatch(ADDRESS_UPDATE_REQUEST, { firstName,surName,gymnasium,profession,birthday,exam,street,zipCode,city,state,country,mobilePhoneNumber,phoneNumber,email,newsletter,visible })
            .then(() => {
              // TODO: reset form
              this.show = false;
              this.successStatus.message = "Deine Adresse wurde erfolgreich übermittelt."
              this.$nextTick(() => { this.show = true });
            })
            .catch(error => {
                this.errorStatus.message = "Die Adresse konnte leider nicht korrekt übermittelt werden. Wende Dich bitte an den Webmaster."
                console.log("MyError: " + error.message)
                this.show = false;
                this.$nextTick(() => { this.show = true });
            })
        },
         onReset (evt) {
              evt.preventDefault();
              /* Reset our form values */

                this.form.firstName= '';
                this.form.surName= '';
                this.form.gymnasium= '';
                this.form.profession= '';
                this.form.birthday= '';
                this.form.exam= '';
                this.form.street= '';
                this.form.zipCode= '';
                this.form.city= '';
                this.form.state= '';
                this.form.country= '';
                this.form.mobilePhoneNumber= '';
                this.form.phoneNumber= '';
                this.form.email= '';
                this.form.newsletter= '';
                this.form.visible= '';

              this.errorStatus.message = '';
              this.successStatus.message = '';
              /* Trick to reset/clear native browser form validation state */
              this.show = false;
              this.$nextTick(() => { this.show = true });
            }
    },
  }
</script>